import React, { useState, useEffect } from 'react';
import { ConditionalLink } from '@plone/volto/components';
import { Image } from 'semantic-ui-react';

const View = (props) => {
  const { data, isEditMode } = props;

  const [cellWidth, setCellWidth] = useState('six');

  useEffect(() => {
    if (data.cells?.length % 2 === 0) {
      setCellWidth('six');
    }

    if (data.cells?.length % 3 === 0) {
      setCellWidth('four');
    }

    if (data.cells?.length % 4 === 0) {
      setCellWidth('three');
    }
  }, [data.cells]);

  return (
    <div className="columns-view info-kacheln-wrapper">
      <div className="ui twelve column grid column-grid">
        {data.cells?.map(
          (
            cell,
            index, // Added index as the second argument if you need it
          ) => (
            <div
              key={index}
              className={`${cellWidth} wide computer twelve wide mobile six wide tablet column column-blocks-wrapper info-kacheln`}
            >
              <ConditionalLink
                to={cell.link?.[0]?.['@id']}
                condition={!isEditMode && cell.link && cell.link[0]}
              >
                <div className="info-content">
                  {cell.image && (
                    <Image
                      src={cell.image['@id'] + '/@@images/image'}
                      alt={cell.alt ? cell.alt : ''}
                    />
                  )}
                  <div className="info-column">
                    <div className="info-title">{cell.title}</div>
                    <div>{cell.text}</div>
                    <div className="info-button">
                      {cell.button_text || cell.title || 'Text einfügen'}
                      {' ↗'}
                    </div>
                  </div>
                </div>
              </ConditionalLink>
            </div>
          ),
        )}
      </div>
    </div>
  );
};

export default View;
